
import { useLanguage } from '@/contexts/LanguageContext';
import ScrollAnimation from './ScrollAnimation';

const ProcessSection = () => {
  const { t } = useLanguage();
  
  return (
    <section className="py-20 md:py-28 px-4 sm:px-6 bg-muted/40">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
          <ScrollAnimation>
            <span className="inline-block px-3 py-1 bg-primary/8 text-primary text-sm font-medium rounded-full border border-primary/15 mb-5">
              {t('process.tag')}
            </span>
          </ScrollAnimation>
          <ScrollAnimation>
            <h2 className="heading-lg" style={{ textWrap: 'balance' }}>
              {t('process.title')}
            </h2>
          </ScrollAnimation>
          <ScrollAnimation>
            <p className="body-md text-muted-foreground mt-4" style={{ textWrap: 'pretty' }}>
              {t('process.description')}
            </p>
          </ScrollAnimation>
        </div>
        
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-[calc(16.67%+24px)] right-[calc(16.67%+24px)] h-px bg-border -translate-y-1/2 z-0" />
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative z-10">
            <ProcessStep step={1} title={t('process.step1.title')} description={t('process.step1.description')} delay={0} />
            <ProcessStep step={2} title={t('process.step2.title')} description={t('process.step2.description')} delay={90} />
            <ProcessStep step={3} title={t('process.step3.title')} description={t('process.step3.description')} delay={180} />
          </div>
        </div>
      </div>
    </section>
  );
};

interface ProcessStepProps {
  step: number;
  title: string;
  description: string;
  delay: number;
}

const ProcessStep = ({ step, title, description, delay }: ProcessStepProps) => {
  return (
    <ScrollAnimation>
      <div 
        className="bg-card rounded-xl p-6 md:p-7 border border-border/60 shadow-sm"
        style={{ transitionDelay: `${delay}ms` }}
      >
        <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-semibold text-sm mb-4 shadow-sm">
          {step}
        </div>
        <h3 className="text-lg font-semibold mb-2 tracking-tight">{title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed" style={{ textWrap: 'pretty' }}>{description}</p>
      </div>
    </ScrollAnimation>
  );
};

export default ProcessSection;
